import { render, staticRenderFns } from "./VmForms.vue?vue&type=template&id=453cc301&"
import script from "./VmForms.vue?vue&type=script&lang=js&"
export * from "./VmForms.vue?vue&type=script&lang=js&"
import style0 from "./VmForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports